import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import LayoutNew from "../components/shared/LayoutNew";
import moment from "moment";

const fallbackNotices = [
  {
    _id: "ck44-wintk",
    msgDate: "2026-08-11",
    message:
      "🎉🎉🎉CK75.live আনুষ্ঠানিকভাবে একটি কৌশলগত ব্র্যান্ড পার্টনারশিপে যুক্ত হয়েছে! 🎆🎆🎆",
    body: "🎁এর মাধ্যমে ব্যবহারকারীদের জন্য আরও আকর্ষণীয় অভিজ্ঞতা, বিশেষ সুবিধা এবং নতুন সুযোগ নিয়ে আসা হবে।🎊\n👑এই পার্টনারশিপ আপনার জন্য কী নিয়ে আসবে?🌈\n1️⃣ বিশেষ সহযোগিতা ও সীমিত এক্সক্লুসিভ পণ্য💸💸💸\n2️⃣ অনলাইন ও অফলাইনে আরও বৈচিত্র্যময় ইন্টার‌যাকশন🎈🎈🎈\n3️⃣ ক্রস-প্ল্যাটফর্ম ব্র্যান্ড ও কমিউনিটি সহযোগিতা💵💵💵\n4️⃣ এক্সক্লুসিভ সুবিধা, সীমিত রিওয়ার্ড এবং বিশেষ ইভেন্ট উপহার।💳💳💳\nআরও নতুন সহযোগিতা, বিশেষ ইভেন্ট এবং এক্সক্লুসিভ সুবিধার জন্য ইভেন্টের বিস্তারিত দেখুন। 🚀🚀🚀",
  },
  {
    _id: "new-year-plan",
    msgDate: "2025-02-19",
    message:
      "🌈🌈🌈নতুন বছরের স্বপ্নের পরিকল্পনা আনুষ্ঠানিকভাবে চালু হয়েছে! 🎉🎉🎉",
    body: "🌟 আপনার প্রথম জমাতে 50% বোনাস পান! 🎉\n💰বন্ধুদের আমাদের সাথে যোগ দিতে আমন্ত্রণ জানান এবং আপনি 1000 টাকা বোনাস পাবেন! 🤝\n🎁 আমরা নতুন সদস্যদের জন্য একটি দ্বিতীয় বিশেষ উপহার প্রস্তুত করেছি, আপনার দেখার অপেক্ষায়! 🎊\n👑 ভিআইপি সদস্যপদ আপগ্রেড পুরষ্কার এবং সাপ্তাহিক/মাসিক মূল্যের সুবিধাগুলি আপনার জন্য অপেক্ষা করছে! 🌈\n📱 আমাদের অ্যাপ ডাউনলোড করুন এবং ১৮ ৳ বোনাস পেতে অফিসিয়াল টেলিগ্রাম চ্যানেল অনুসরণ করুন! 💸",
  },
];

const Notice = () => {
  const navigate = useNavigate();
  const messages = useContextSelector(AuthContext, (ctx) => ctx.messagelist);
  const [openId, setOpenId] = useState(0);
  const items = useMemo(
    () => (messages?.length ? messages : fallbackNotices),
    [messages],
  );

  useEffect(() => {
    document.body.classList.add("ck-home");
    return () => document.body.classList.remove("ck-home");
  }, []);

  return (
    <LayoutNew>
      <div className="notice-page">
        <div className="notice-page-bar">
          <button type="button" aria-label="Back" onClick={() => navigate(-1)}>
            ‹
          </button>
          <h1>Announcement</h1>
        </div>
        {items.map((item, index) => {
          const id = item?._id || item?.msgDate || index;
          const open = openId === index;
          const date = item?.msgDate || item?.createdAt;
          const body = item?.body || item?.message;
          return (
            <article className={`notice-card${open ? " open" : ""}`} key={id}>
              <button
                type="button"
                className="notice-card-head"
                onClick={() => setOpenId(open ? -1 : index)}
              >
                <div>
                  <strong>{item?.message}</strong>
                  {date ? <time>{moment(date).format("YYYY-MM-DD")}</time> : null}
                </div>
                <span className="notice-card-arrow" />
              </button>
              {open ? (
                <div className="notice-card-body">
                  <p>{body}</p>
                </div>
              ) : null}
            </article>
          );
        })}
      </div>
    </LayoutNew>
  );
};

export default Notice;
